import { memo } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
// Import Store
import { useAppSelector } from 'store';
import { selectAuthIsLoggedIn } from 'store/slices/auth';
// Import Constants
import { BrowserStorageKeys } from 'constants/browserStorage';
import { RoutesList } from 'routes/constants';

const { CRM_SIGN_IN, SSO_SIGN_IN, CRM_RESET_PASSWORD, CRM_RESET_PASSWORD_CONFIRM } = RoutesList;

interface Props {
    path: string;
    component: React.ComponentType<{ titleKey?: string }>;
    titleKey?: string;
}

const PrivateRoute: React.FC<Props> = ({ path, titleKey, component: Component }) => {
    const { pathname, search } = useLocation();
    const isLoggedIn = useAppSelector(selectAuthIsLoggedIn);

    const token = localStorage.getItem(BrowserStorageKeys.accessToken);
    const isCRMSignIn = localStorage.getItem(BrowserStorageKeys.isCRMSignIn) === 'true';
    const isNotCRMAuthURL = [CRM_SIGN_IN.path, CRM_RESET_PASSWORD.path, CRM_RESET_PASSWORD_CONFIRM.path].every(
        (path) => !pathname.includes(path),
    );

    if (isLoggedIn) {
        return (
            <Route path={path}>
                <Component titleKey={titleKey} />
            </Route>
        );
    } else if (isLoggedIn !== null || isEmpty(token)) {
        localStorage.setItem(BrowserStorageKeys.showMaintenanceModal, 'true');

        if (isEmpty(token) && isNotCRMAuthURL) {
            localStorage.setItem(BrowserStorageKeys.directUrl, pathname + search);
        }

        if (isCRMSignIn) {
            return <Redirect to={`/${CRM_SIGN_IN.path}`} />;
        }

        return <Redirect to={`/${SSO_SIGN_IN.path}`} />;
    }

    return null;
};

export default memo(PrivateRoute);
